import React from 'react';
import PropTypes from 'prop-types';

const PopupCartLimit = ({ execActionConfirm = null }) => {

    const maxLimit = localStorage.getItem("maxLimit");
    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    }

    return (
        <div id="message-popup-terms" className="white-popup message-popup-simple">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4 red">
                                    <strong>Aviso</strong>
                                </p>
                                <div className="text-center mb-4">
                                    <p>Se pueden usar como máximo {maxLimit} cupones</p>
                                </div>
                                <div className="text-center">
                                    <a href="#" onClick={(event) => handleConfirm(event)} className="btn">
                                        Aceptar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

PopupCartLimit.propTypes = {
    execActionConfirm: PropTypes.func
};

export default PopupCartLimit;
